export const typeToEnglish = {
    2: "Standard",
    3: "Classic",
    4: "Exotic",
};
